import { Info } from "lucide-react";
import React from "react";

const InfoBulle: React.FC<{ message: string }> = ({ message }) => {
  return (
    <div className=" flex border-[1px] rounded-xl p-2">
      <div className="flex items-center">
        <Info className="flex items-center" color="grey" size="20" />
      </div>
      <span className="text-[14px] font-['Raleway'] ml-2">
        { message }
      </span>
    </div>
  );
}

export default InfoBulle;
